"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _glamor = require("glamor");

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _utils = require("@quixeltools/quixel-ui-library/dist/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popup = (0, _glamor.css)(_css.coverFixed, {
  background: "rgba(0, 0, 0, 0.8)",
  zIndex: 10000
  // overflow:'scroll'
});

var close = function close(showWhite) {
  return (0, _glamor.css)(_css.btnReset, {
    position: "absolute",
    top: "16px",
    right: "19px",

    zIndex: 1,
    width: "0.625rem",
    height: "0.625rem",

    cursor: "pointer",
    transition: "all " + _css.time.fast,
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "16px",

    ":hover": {
      //transform: 'scale(1.1, 1.1)',
      color: "#eee"
    },
    ":after": {
      content: '"✕"',
      width: "100%"
    }
  });
};

var arrow = (0, _glamor.css)({
  transform: "rotate(45deg) translateY(-50%)",
  cursor: "pointer",
  position: "absolute",
  top: "50%",
  padding: "10px 10px 20px 20px",
  background: "none",
  border: "none",
  outline: "none",
  opacity: 0.5,
  transition: "all " + _css.time.fast,
  "&:hover": {
    opacity: 1,
    transform: "rotate(45deg) translateY(-50%) scale(1.05, 1.05)"
  },
  "& > div": {
    width: "1.4vw",
    height: "1.4vw",
    minWidth: "2em",
    minHeight: "2em"
  }
});

var leftArrow = (0, _glamor.css)(arrow, {
  left: "-10px",
  "& > div": {
    borderBottom: "1px solid #fff",
    borderLeft: "1px solid #fff"
  }
});
var rightArrowLink = (0, _glamor.css)({
  width: "80%",
  display: "block",
  position: "absolute",
  top: "50%",
  maxWidth: "calc(100% - 300px)"
});

var rightArrow = (0, _glamor.css)(arrow, {
  right: "30px",
  "& > div": {
    borderTop: "1px solid #fff",
    borderRight: "1px solid #fff"
  }
});

var children = function children(isChildLargerThanScreen) {
  return (0, _glamor.css)(_css.center, {
    transform: "none",
    top: 0,
    left: 0
  }, (0, _css.minWidth)(_css.breakpoints.medium)(_css.center));
};

var outsideClick = function outsideClick(onClose) {
  return function (ev) {
    if (ev.currentTarget === ev.target.parentNode.parentNode) {
      onClose();
    }
  };
};

var PopupContainer = function (_React$Component) {
  (0, _inherits3.default)(PopupContainer, _React$Component);

  function PopupContainer() {
    (0, _classCallCheck3.default)(this, PopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PopupContainer.__proto__ || (0, _getPrototypeOf2.default)(PopupContainer)).call(this));

    _this.onKeyPress = _this.onKeyPress.bind(_this);
    _this.referenceToChild = _this.referenceToChild.bind(_this);
    _this.onWindowResize = _this.onWindowResize.bind(_this);
    _this.state = {
      isChildLargerThanScreen: false
    };
    return _this;
  }

  (0, _createClass3.default)(PopupContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!__SERVER__) {
        window.addEventListener("resize", this.onWindowResize);
        window.addEventListener("keydown", this.onKeyPress);
      }
      if ((0, _utils.detectMobileAndTablet)() && window.innerWidth <= 812) document.getElementsByTagName("body")[0].style.position = "fixed";
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keydown", this.onKeyPress);
      window.removeEventListener("resize", this.onWindowResize);
      if ((0, _utils.detectMobileAndTablet)() && window.innerWidth <= 812) document.getElementsByTagName("body")[0].style.position = "unset";

      //required for signup popup, as we set body overflow hidden if popup open, and reset on unmount.
      document.body.style.overflowY = "auto";
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      var _this2 = this;

      if (!this.issizing) {
        this.issizing = true;
        setTimeout(function () {
          _this2.forceUpdate();
          _this2.issizing = false;
        }, 200);
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(ev) {
      var props = this.props;

      switch (ev.keyCode) {
        case 27:
          // escape
          if (typeof props.showWhiteCloseBtn == "undefined") props.onClose();
          break;

        case 37:
          // left
          if (!!props.previousTo && !!props.previousTo()) {
            props.onPreviousClick();
          }
          break;

        case 39:
          // right
          if (!!props.nextTo && !!props.nextTo()) {
            props.onNextClick();
          }
          break;

        default:
          break;
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "onMouseWheel",
    value: function onMouseWheel(e) {
      var delta = e.deltaY;

      var scrollElement = e.target.closest("#scrollingDiv");
      if (!scrollElement) {
        scrollElement = e.currentTarget.firstChild.firstChild;
      }

      var scrollPos = scrollElement.scrollTop;
      var maxScroll = scrollPos + scrollElement.clientHeight;
      var scrollHeight = scrollElement.scrollHeight;

      //specifically id added to signup popup to explicitly handle signup popup scroll issue for dropdown.
      var signupFormElem = document.getElementById("signupScroll");
      if (signupFormElem) {
        document.body.style.overflowY = "hidden";
      }

      if (scrollPos === 0 && delta < 0 || maxScroll >= scrollHeight - 4 && delta > 0) {
        if (!signupFormElem) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }, {
    key: "referenceToChild",
    value: function referenceToChild(child) {
      if (__CLIENT__ && child && window.innerHeight < child.getBoundingClientRect().height + 60) {
        this.setState({
          isChildLargerThanScreen: true
        });
      } else {
        this.setState({
          isChildLargerThanScreen: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var isChildLargerThanScreen = this.state.isChildLargerThanScreen;


      var isFullScreen = null;
      if (typeof props.children.props.location !== "undefined" && props.children.props.location.state !== undefined) {
        isFullScreen = props.children.props.location.state.fullScreen;
      }

      var isWindowSmall = window.innerWidth < 768;
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return _react2.default.createElement(
        "div",
        {
          tabIndex: "0",
          className: popup,
          onClick: outsideClick(props.onClose),
          onWheel: this.onMouseWheel
        },
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          { autoHide: true, universal: true },
          _react2.default.createElement(
            "div",
            {
              className: (0, _glamor.css)((0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                height: "100%",
                width: "100%"
              }), children(isChildLargerThanScreen)),
              style: isFullScreen ? { height: "100%", width: "100%" } : {}
            },
            _react2.default.cloneElement(props.children, {
              childReference: this.referenceToChild
            }),
            !isFullScreen && _react2.default.createElement("button", { className: close(true), onClick: function onClick() {
                return props.onClose();
              } })
          ),
          isFullScreen && _react2.default.createElement("button", { className: close(true), onClick: function onClick() {
              return props.onClose();
            } }),
          !isWindowSmall && !!props.previousTo && !!props.previousTo() && _react2.default.createElement(
            _reactRouter.Link,
            { to: props.previousTo() },
            _react2.default.createElement(
              "button",
              { className: leftArrow },
              _react2.default.createElement("div", null)
            )
          ),
          !isWindowSmall && !!props.nextTo && !!props.nextTo() && _react2.default.createElement(
            _reactRouter.Link,
            { className: rightArrowLink, to: props.nextTo() },
            _react2.default.createElement(
              "button",
              { className: rightArrow },
              _react2.default.createElement("div", null)
            )
          )
        )
      );
    }
  }]);
  return PopupContainer;
}(_react2.default.Component);

exports.default = PopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppPopupContainer/PopupContainer.jsx
// module id = 1211
// module chunks = 0